/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from './Footer.module.css';

function Footer () {
    return(
        <>
            <footer className={styles.footer}>
                <h2>Salão do Nego &copy; Desenvolvido por Giovani Teodoro Martins</h2>
            </footer>
        </>
    )
}
    
export default Footer;